import Vue from 'vue'
import AppCells from '@/components/AppCells'
import AppCellsGrid from '@/components/AppCellsGrid'
import AppButton from '@/components/AppButton'
import AppFormGroup from '@/components/AppFormGroup'
import AppInput from '@/components/AppInput'
import AppFinNumber from '@/components/AppFinNumber'
import AppPhone from '@/components/AppPhone'
import AppCheckbox from '@/components/AppCheckbox'
import AppRadio from '@/components/AppRadio'
import AppSwitcher from '@/components/AppSwitcher'
import AppCropperWebCam from '@/components/AppCropperWebCam'
import AppUploader from '@/components/AppUploader'
import AppTableLimit from '@/components/AppTableLimit'
import AppTableRecords from '@/components/AppTableRecords'
import AppFilters from '@/components/AppFilters'
import AppSpinner from '@/components/AppSpinner'
import AppBlockLoader from '@/components/AppBlockLoader'
import AppGrid from '@/components/AppGrid'
import AppTextarea from '@/components/AppTextarea'
import AppSelect from '@/components/AppSelect'
import AppDatePicker from '@/components/AppDatePicker'
import AppFlexGrid from '@/components/AppFlexGrid.vue'
import AppForm from '@/components/AppForm.vue'
import AppNoResults from '@/components/AppNoResults.vue'
import AppPageContainer from '@/components/AppPageContainer.vue'
import AppFormField from '@/components/AppFormField.vue'
import AppCard from '@/components/AppCard.vue'
import AppMetricCard from '@/components/AppMetricCard.vue'
import AppModalHeader from '@/components/AppModalHeader.vue'
import AppPageHeader from '@/components/AppPageHeader.vue'
import AppStatusBadge from '@/components/AppStatusBadge.vue'
import AppPagination from '@/components/AppPagination.vue'
import AppClearFiltersButton from '@/components/AppClearFiltersButton.vue'
import AppDataTable from '@/components/AppDataTable.vue'
import AppDateRangePicker from '@/components/AppDateRangePicker.vue'
import AppIconButton from '@/components/AppIconButton.vue'
import AppFilterToolbar from '@/components/AppFilterToolbar.vue'

Vue.component('AppCells', AppCells)
Vue.component('AppCellsGrid', AppCellsGrid)
Vue.component('AppButton', AppButton)
Vue.component('AppFormGroup', AppFormGroup)
Vue.component('AppInput', AppInput)
Vue.component('AppFinNumber', AppFinNumber)
Vue.component('AppPhone', AppPhone)
Vue.component('AppCheckbox', AppCheckbox)
Vue.component('AppRadio', AppRadio)
Vue.component('AppSwitcher', AppSwitcher)
Vue.component('AppCropperWebCam', AppCropperWebCam)
Vue.component('AppUploader', AppUploader)
Vue.component('AppTableLimit', AppTableLimit)
Vue.component('AppTableRecords', AppTableRecords)
Vue.component('AppFilters', AppFilters)
Vue.component('AppSpinner', AppSpinner)
Vue.component('AppBlockLoader', AppBlockLoader)
Vue.component('AppGrid', AppGrid)
Vue.component('AppTextarea', AppTextarea)
Vue.component('AppSelect', AppSelect)
Vue.component('AppDatePicker', AppDatePicker)
Vue.component('AppFlexGrid', AppFlexGrid)
Vue.component('AppForm', AppForm)
Vue.component('AppNoResults', AppNoResults)
Vue.component('AppPageContainer', AppPageContainer)
Vue.component('AppFormField', AppFormField)
Vue.component('AppCard', AppCard)
Vue.component('AppMetricCard', AppMetricCard)
Vue.component('AppModalHeader', AppModalHeader)
Vue.component('AppPageHeader', AppPageHeader)
Vue.component('AppStatusBadge', AppStatusBadge)
Vue.component('AppPagination', AppPagination)
Vue.component('AppClearFiltersButton', AppClearFiltersButton)
Vue.component('AppDataTable', AppDataTable)
Vue.component('AppFilterToolbar', AppFilterToolbar)
Vue.component('AppIconButton', AppIconButton)
Vue.component('AppDateRangePicker', AppDateRangePicker)
